import { Link } from "react-router-dom";
import { QuoteButton } from "@/components/Buttons";

export default function NotFound() {
  return (
    <section className="flex min-h-screen flex-col items-center justify-center bg-brand-blue px-5 text-center text-white">
      <div className="font-display text-8xl font-bold text-brand-gold">404</div>
      <h1 className="mt-4 font-display text-3xl font-semibold">Page not found</h1>
      <p className="mt-3 max-w-md text-slate-300">
        The page you're looking for doesn't exist or has moved.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-full border border-white/25 px-7 py-3.5 font-medium hover:bg-white hover:text-brand-blue transition-colors">
          Back to Home
        </Link>
        <QuoteButton />
      </div>
    </section>
  );
}
